<template>
    <div class="text-title">
        <h1
            v-if="title"
            v-html="title"
        />
        <h3
            v-if="description"
            v-html="description"
        />
    </div>
</template>

<script>
export default {
    name: 'TitleText',
    components: {
    },
    props: {
        title: String,
        description: String
    }
}
</script>

<style
    lang="scss"
    scoped
>
/* Centered on mobile (matches the centered content below every
   section title); left-aligned from tablet up, where sections have
   room for the editorial left-rag look. */
.text-title {
    text-align: center;
    max-width: 640px;
    margin: 0 auto 36px;

    h1 {
        font-size: clamp(28px, 4vw, 40px);
        line-height: 1.15;
    }

    h3 {
        margin: 12px 0 0;
        font-weight: 500;
        opacity: 0.75;
    }
}
</style>
